module.exports = __webpack_public_path__ + "img/parliament-2.4ff5cbb4.webp";